import CityPageTemplate from "../city-template/CityPageTemplate";
import { midlandConfig } from "./data";

export default function MidlandPage() {
  return <CityPageTemplate config={midlandConfig} />;
}